'use strict';

module Dashboard {

    class DashboardCsrConversation {
        csr:any;
        isInProgress:boolean = false;

        constructor(private $scope,
                    private dashboardCsrService,
                    private $timeout) {

            $('.header-main').addClass('unfix');

            $scope.$watch('csd.csr.newMessage', ()=> this.moveConversationWithTextbox());

        }

        submitMessage = csr => {
            this.isInProgress = true;
            this.dashboardCsrService.submitMessage(csr).then(() => this.isInProgress = false);
        }

        getSenderTitle = conversation => this.dashboardCsrService.getSenderTitle(conversation);

        goToBottom() {
            this.$timeout(function () {
                scrollTo(0, document.body.scrollHeight);
            }, 2000);
        }

        moveConversationWithTextbox() {
            //to move the conversation are when the input are height increases.
            const el = $('.csr-conversation');
            el.css('padding-bottom', $('.csr-send-message').css('height'));
        }

    }

    angular
        .module('dashboard')
        .component('dashboardCsrConversation', {
            bindings: {
                csr: '='
            },
            controller: DashboardCsrConversation,
            controllerAs: 'csd',
            templateUrl: 'partials/dashboard/CsrConversation'
        });

}
